import * as React from 'react';

import * as style from 'styles/components/match/page/matchField.module.scss';

const MatchLineUpField = ({ match: { match } }) => {
    const getFormation = (composition, lineUp) => {
        let positionIndex = 0;

        // Add the goal to the composition and split the composition (11 players) to create rows
        // Ex. 3-5-2 becomes [1, 3, 5, 2]
        const compositionWithGoal = ['1'].concat(composition.split('-'));

        // Map the players position for each rows
        // Ex. [1, 3, 5, 2] becomes [[1], [2, 3, 4], [5, 6, 7, 8, 9], [10, 11]]
        // Then return the position and the player Number for each position
        return compositionWithGoal
            .map(Number)
            .map(row => [...Array(row)].map(() => {
                positionIndex += 1;
                const playerForIndex = lineUp.find(player => player.fieldPosition === positionIndex);

                return {
                    playerPosition: positionIndex,
                    playerNumber: playerForIndex && playerForIndex.player.number,
                };
            }));
    };

    const fieldGridStyle = (composition) => {
        const gridColumns = composition.split('-').length + 1;
        return { gridTemplateColumns: `repeat(${gridColumns}, auto)` };
    };

    const circleClass = (isHammarby) => [
        style.matchField__playerCircle,
        isHammarby ? style.matchField__playerCircleHome : style.matchField__playerCircleAway,
    ].join(' ');

    if (!match.localLineupComposition || !match.externalLineupComposition) return null;

    return (
        <div className={style.matchField__section}>
            <div className={style.matchField__wrapper}>
                <div className={style.matchField}>

                    <div className={style.matchField__team} style={fieldGridStyle(match.localLineupComposition)}>
                        {getFormation(match.localLineupComposition, match.localLineup)
                            .map((fieldRow, fieldRowIndex) => (
                                <div key={fieldRowIndex} className={style.matchField__fieldSection}>
                                    {fieldRow.reverse().map((fieldPosition, fieldPositionIndex) => (
                                        <div key={fieldPositionIndex} className={circleClass(match.local.isHammarby)}>
                                            {fieldPosition.playerPosition}
                                        </div>
                                    ))}
                                </div>
                            ))
                        }
                    </div>

                    <div className={style.matchField__team} style={fieldGridStyle(match.externalLineupComposition)}>
                        {getFormation(match.externalLineupComposition, match.externalLineup)
                            .reverse()
                            .map((fieldRow, fieldRowIndex) => (
                                <div key={fieldRowIndex} className={style.matchField__fieldSection}>
                                    {fieldRow.map((fieldPosition, fieldPositionIndex) => (
                                        <div key={fieldPositionIndex}
                                             className={circleClass(match.external.isHammarby)}>
                                            {fieldPosition.playerPosition}
                                        </div>
                                    ))}
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MatchLineUpField;
